if (!customElements.get('adev-new-faq')) {
    customElements.define('adev-new-faq', class adevNewFaq extends HTMLElement {
        constructor() {
            super();
        }

        shopifyCustomizerInit(){
            if (!Shopify.designMode) return;

            document.addEventListener('shopify:block:select', (event) => {
                const blockId = event.detail.blockId;

                const blockElement = this.querySelector(`[data-id="${blockId}"]`);
                if (blockElement) {
                    const detailsElement = blockElement.querySelector('details');
                    if (detailsElement) {
                        detailsElement.open = true;
                    }
                }

            });
        }

        connectedCallback() {
            this.shopifyCustomizerInit();
        }

        disconnectedCallback() {
            
        }

    });
}